




































import Vue from 'vue';

enum DateOffsetType {
  Before = -1,
  Today = 0,
  After = 1,
}

const time: string | undefined = undefined;

export default Vue.extend({
  data() {
    return {
      days: 0,
      time,
      dateOffsetType: DateOffsetType.Before,
      DateOffsetType,
    };
  },
  props: {
    timeFieldBased: {
      type: Object,
      default: null,
    },
  },
  computed: {
    triggerDayOffset(): number {
      if (this.dateOffsetType === DateOffsetType.Today) {
        return 0;
      } else if (this.dateOffsetType === DateOffsetType.Before) {
        return 0 - this.days;
      } else {
        return this.days;
      }
    },
  },
  methods: {
    confirmRemindTime() {
      if (this.validate()) {
        this.$store.commit('UPDATE_TIME_FIELD_BASED', {
          key: 'triggerDayOffset',
          value: this.triggerDayOffset,
        });
        this.$store.commit('UPDATE_TIME_FIELD_BASED', {
          key: 'triggerTime',
          value: this.time,
        });
        this.$emit('close');
      }
    },
    validate() {
      if (this.dateOffsetType !== DateOffsetType.Today &&
        (!this.days || this.days < 0)) {
        this.$Message.warning('请填写正确的天数');
        return false;
      } else if (!this.time || (this.time! as string).trim() === '') {
        this.$Message.warning('请选择时间');
        return false;
      } else {
        return true;
      }
    },
    initTimeFieldBased() {
      if (this.timeFieldBased.triggerTime) {
        const tfb = JSON.parse(JSON.stringify(this.timeFieldBased));
        if (tfb.triggerDayOffset === 0) {
          this.dateOffsetType = DateOffsetType.Today;
        } else if (tfb.triggerDayOffset > 0) {
          this.dateOffsetType = DateOffsetType.After;
        } else {
          this.dateOffsetType = DateOffsetType.Before;
        }
        this.days = Math.abs(tfb.triggerDayOffset);
        this.time = tfb.triggerTime;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initTimeFieldBased();
    });
  },
});
